<template>
  <div>
    <div class="div0">
      <div class="div1">
        <!--<el-form :model="chaXun" class="demo-form-inline">-->
          <!--<el-form-item label="供暖卡号" prop="id" style="margin-left: 5%;font-weight: bolder;">-->
            <span style="font-weight: bolder;margin-left: -3%;font-size: small;color: #333333">供暖卡号</span>
            <input class="input1" v-model="chaXun.id" size="small" />
          <!--</el-form-item>-->
          <!--<el-form-item class="chaxun">-->
            <el-button type="success" size="small" style="padding: 8px 18px; margin-left: 4%" @click="search(chaXun.id)">
              查询
            </el-button>
          <!--</el-form-item>-->
        <!--</el-form>-->
      </div>
      <div class="div2">
        <el-row>
          <el-col :span="5" class="biaoti">供暖卡号</el-col>
          <el-col :span="5" class="xiangqing">{{xinXi.clientCode}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">用户姓名</el-col>
          <el-col :span="16" class="xiangqing">{{xinXi.clientMstName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">小区名称</el-col>
          <el-col :span="16" class="xiangqing">{{xinXi.housingEstateName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">楼牌住址</el-col>
          <el-col :span="16" class="xiangqing">{{xinXi.housingAdd}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">商网名称</el-col>
          <el-col :span="16" class="xiangqing">{{xinXi.clientMstSellerName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">联系电话</el-col>
          <el-col :span="16" class="xiangqing">{{xinXi.clientMstMobile}}</el-col>
        </el-row>
      </div>
      <div class="div3">
        <el-row>
          <el-col class="mianji" style="font-weight: bolder">供暖面积（平方米）</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" style="margin-left: 5%">住宅面积</el-col>
          <span style=" margin-left:  -45%;position: relative;top: 2px;">{{xinXi.residentArea}}</span>
          <el-col :span="5" style="float: left; margin-left: 25%">商网面积</el-col>
          <span style="position:absolute;left: 73%;top: 10%;">{{xinXi.houseMstSellerArea}}</span>
        </el-row>
        <el-row>
          <el-col :span="5" style="margin-left: 5%">企业面积</el-col>
          <span style="margin-left: -45%;position: relative;top: 2px;">{{xinXi.houseMstOther1Area}}</span>
          <el-col :span="5" style="float: left;margin-left: 25%">其他面积</el-col>
          <span style="position:absolute;left: 73%;top: 10%;">{{xinXi.houseMstOther2Area}}</span>
        </el-row>
      </div>
    </div>
    <div class="div4">
      <el-button style="width: 70%;" size="small" type="success"  v-bind:disabled="addState" @click="addInfor()">提交
      </el-button>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'

  export default {
    name: "addHouseProperty",
    data() {
      // var idCheck = (rule, value, callback) => {
      //   var card = /^[0-9a-zA-Z]*$/g;
      //   if (!value) {
      //     callback(new Error("卡号不可以为空"))
      //   } else if (!card.test(value)) {
      //     callback(new Error("卡号格式不对"))
      //   } else {
      //     callback();
      //   }
      // }
      return {
        openID: this.$store.getters.getUserInfo.openID,
        //this.$store.getters.getUserInfo.openID
        userID: this.$store.getters.getUserInfo.userID,
        //this.$store.getters.getUserInfo.userID
        chaXun: {
          id: '',
        },
        addState: true,
        xinXi: {
          clientCode: '',
          clientMstName: '',
          housingEstateName: '',
          housingAdd: '',
          clientMstSellerName: '',
          clientMstMobile: '',
          residentArea: '',
          houseMstSellerArea: '',
          houseMstOther1Area: '',
          houseMstOther2Area: '',
        }
        // rules: {
        //   id: [
        //     {max: 20, message: '输入卡号过长', trigger: 'blur'},
        //     {validator: idCheck, trigger: 'blur'},
        //   ]
        // }
      }
    },
    created () {
      this.keyupSubmit()
    },
    methods: {
      keyupSubmit () {
        document.onkeydown = e => {
          let _key = window.event.keyCode;
          if (_key === 13) {
            this.search(this.chaXun.id)
          }
        }
      },
      search (id) {
        this.xinXi = {
          clientCode: '',
          clientMstName: '',
          housingEstateName: '',
          housingAdd: '',
          clientMstSellerName: '',
          clientMstMobile: '',
          residentArea: '',
          houseMstSellerArea: '',
          houseMstOther1Area: '',
          houseMstOther2Area: ''
        };
        this.addState = true
          var card = /^[0-9a-zA-Z]*$/g;
            if (id != "") {
              if (id.length <= 20) {
                if (card.test(id)) {
                  let params = {
                    clientCode: this.chaXun.id
                  }
                  this.$http.getClientDetails(params).then(response => {
                    if (response.data == null) {
                      Toast({
                        duration: 2000,
                        message: '卡号不存在或已被删除！'
                      })
                    } else {
                      let value = response.data.row  [0]
                      if (value.clientMstName.length > 0) {
                        // value.clientMstName = value.clientMstName.replace(/.(?=.)/g, '*');
                        value.clientMstName = '**' +  value.clientMstName.substr(-1)
                      }
                      if (value.clientMstMobile !== "-") {
                        value.clientMstMobile = value.clientMstMobile.replace(/(\d{3})\d{5}(\d{3})/, "$1*****$2");
                      }
                      this.xinXi = value
                      this.addState = false
                    }
                  })
                }else {
                  Toast({
                    duration: 2000,
                    message: '卡号格式不对'
                  })
                }
              }else {
                Toast({
                  duration: 2000,
                  message: '输入卡号过长'
                })
              }
            }else {
              Toast({
                duration: 2000,
                message: '请输入卡号'
              })
            }
      },
      addInfor() {
        if (this.chaXun.id === "") {
          Toast({
            duration: 2000,
            message: '请填写卡号'
          })
        } else {
          if (this.xinXi.clientCode == "") {
            Toast({
              duration: 2000,
              message: '没有可添加的信息'
            })
          } else {
            let params = {
              openID: this.openID,
              userID: this.userID,
              clientCode: this.xinXi.clientCode
            }
            this.$http.addHousing(params).then(response => {
              if (response.state === 1) {
                Toast({
                  duration: 2000,
                  message: '添加成功'
                })
                let _this = this
                setTimeout(function () {

                  _this.tiaoZhuan()//娃娃消失

                }, 1000); //延迟1秒
              } else {
                Toast({
                  duration: 2000,
                  message: response.msg
                })
              }
            })
          }
        }
      },
      tiaoZhuan() {
        this.$router.push({name: 'houseProperty'})
      }
    }
  }
</script>

<style scoped>
  .div0 {
    position: absolute;
    width: 100%;
    height: 91%;
    top: 0;
    left: 0;
    overflow-x: hidden;
  }

  .div1 {
    height: 95px;
    text-align: center;
  }

  .demo-form-inline {
    position: relative;
    top: 35%;
  }

  .chaxun {
    position: absolute;
    top: -0%;
    left: 75%;
  }

  .input1 {
    width: 170px;
    height: 20px;
    /*margin-left: -35%;*/
    padding: 5px;
    border: 1px solid #DCDFE6; /*#DCDFE6*/
    border-radius: 4px;
    -webkit-appearance: none;
    line-height: 0px;
    margin-top: 10%;
    margin-left: 2%;
    outline: none;
  }

  .biaoti {
    font-weight: bolder;
    margin-left: 6%;
  }

  .xiangqing {
    margin-left: 2%;
  }

  .div2 {
    padding-top: 3%;
    border: 1px;
    border-style: solid;
    border-color: gainsboro white white;
  }

  .div3 {
    margin-top: 5%;
    padding-top: 3%;
    border: 1px;
    border-style: solid;
    border-color: gainsboro white white;
  }

  .el-row {
    margin-top: 5%;
  }

  .mianji {
    margin-left: 4%;
  }

  .div4 {
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
    background-color: #fff;
  }

  .zzmj {
    margin-top: 2%;
    margin-left: 8%;
  }

  .swmj {
    position: relative;
    left: 55%;
    top: -62px;
  }

  .qymj {
    position: relative;
    left: 8%;
    top: -95px;
  }

  .qtmj {
    position: relative;
    left: 55%;
    top: -157px;
  }
</style>
<style>
  .el-form-item__error {
    position: absolute;
    top: 100%;
    left: 22%;
  }

  .el-message--warning {
    width: 50%;
  }

  .el-col-5 {

  }

</style>



// WEBPACK FOOTER //
// src/pages/addHouseProperty.vue